import { reactive } from 'vue'

export const toasts = reactive([])
let nextId = 1

// toast('Added to bag', { action: { label: 'View bag', to: '/cart' } })
// toast('Removed', { action: { label: 'Undo', handler: () => restore() } })
export function toast(message, { action = null, tone = 'default', duration = 3200 } = {}) {
	const id = nextId++
	toasts.push({ id, message, action, tone })
	setTimeout(() => dismissToast(id), duration)
	return id
}

export function dismissToast(id) {
	const index = toasts.findIndex((t) => t.id === id)
	if (index > -1) toasts.splice(index, 1)
}
